import { FC, ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';
import './style.scss';

export const OrderProductSkeleton: FC = (): ReactElement => {
  return (
    <div className="order-product-skeleton">
      <Skeleton width={200} height={24} />
      <Skeleton width={55} height={19.2} />
    </div>
  );
};
